import FileDownload from 'react-file-download'
import { toast } from 'react-toastify'
import Immutable from 'immutable'
import moment from 'moment'

import * as types from './types'
import { getUserFromToken, signOut } from './auth'
import { createAxiosInstance, uploadMaxSize, isFunction, acceptedFiles, getModificaciones, groupModificacionesBy, guid, verificacionSST, getTotalesDocumento } from '../utils/helpers'
import { API_URL, API_IATACODES } from './index'
import { getDocumento } from './documentos';
import { isMoment } from 'moment';



export function displayMessages(dispatch, msg) {
    let obj = { type: 'warning', message: '' }
    let message = ''
    if (msg.response) {
        switch(msg.response.status) {
            case 500:
                message = (msg && msg.response && msg.response.data && msg.response.data.message) ? msg.response.data.message : msg.response.data.ExceptionMessage
                message = message ? message : msg.response.data.Message
                dispatch({ type: types.MOSTRAR_MODAL_ERROR, payload: { show: true, message: message }})
                break;
            case 401:
                dispatch({ type: types.MOSTRAR_MENSAJE, payload: { type: 'danger', message: 'No está autorizado para proceder con esta solicitud. Por favor, inicie sesión y vuelva a intentarlo' } })
                dispatch(signOut())
                break;
            case 400:
                if (msg.response.data.ModelState) {
                    for (let property in msg.response.data.ModelState) {
                        if (msg.response.data.ModelState.hasOwnProperty(property)) {
                            for (let n = 0; n < msg.response.data.ModelState[property].length; n++) {
                                dispatch({type: types.MOSTRAR_MENSAJE, payload: { type: 'danger', message: msg.response.data.ModelState[property][n] }})
                            }
                        }
                    }
                } else if (msg.response.data.error) {
                    dispatch({type: types.MOSTRAR_MENSAJE, payload: { type: 'danger', message: msg.response.data.error_description }})
                }
                break;
            case 422:
                for (let property in (msg && msg.response && msg.response.data && msg.response.data.errors) || {}) {
                    if (msg.response.data.errors.hasOwnProperty(property)) {
                        for (let n = 0; n < msg.response.data.errors[property].length; n++) {
                            dispatch({ type: types.MOSTRAR_MENSAJE, payload: { type: 'warning', message: msg.response.data.errors[property][n] }})
                        }
                    }
                }
                break;
            case 405:
                if (msg.response.data.message) {
                    dispatch({ type: types.MOSTRAR_MODAL_ERROR, payload: { show: true, message: msg.response.data.message }})
                }
                break;

            case 403:
                dispatch({type: types.MOSTRAR_MENSAJE, payload: { type: 'danger', message: 'Acceso Denegado' }})
                break;

            default:

        }
    } else {
        if (msg.data) {
            obj.message = msg.data.Message
            dispatch({ type: types.MOSTRAR_MENSAJE, payload: obj })
        } else if (msg.message) {
            obj.type = 'danger'
            obj.message = msg.message
            dispatch({ type: types.MOSTRAR_MENSAJE, payload: obj })
        } else if (msg.info) {
            obj.type = 'info'
            obj.message = msg.info
            dispatch({ type: types.MOSTRAR_MENSAJE, payload: obj })
        } else if (msg.success) {
            obj.type = 'success'
            obj.message = msg.success
            dispatch({ type: types.MOSTRAR_MENSAJE, payload: obj })
        } else if (msg.warning) {
            if (msg.warning instanceof Array) {
                for (let n = 0; n < msg.warning.length; n++) {
                    const payload = { type: 'warning', message: msg.warning[n] }
                    const fn = (d) => d({ type: types.MOSTRAR_MENSAJE, payload })
                    fn(dispatch)
                }
            } else {
                obj.type = 'warning'
                obj.message = msg.warning
                dispatch({ type: types.MOSTRAR_MENSAJE, payload: obj })
            }
        } else {
            obj.type = 'danger'
            obj.message = msg
            dispatch({ type: types.MOSTRAR_MENSAJE, payload: obj })
        }
    }
}

export function clearMessage() {
    return (dispatch) => {
        dispatch({ type: types.LIMPIAR_MENSAJES })
    }
}

export function getUserConfig() {
    return (dispatch) => {
        getUserFromToken()
        .then(data => {
            const fn2 = d => d({ type: types.ASIGNAR_USUARIO_SESION, payload: data })
            fn2(dispatch)
        })
        .catch(err => {
            console.log(err, err.response)
            if (err.response && err.response.data.status === 401) {
                dispatch(signOut())
            }
        })
    }
}

export function showHideModalMsgBox(show = false, message = null) {
    return (dispatch) => {
        dispatch({ type: types.MOSTRAR_MODAL_ERROR, payload: { show, message } })
    }
}

export function expandCollapseModule(moduloId) {
    return (dispatch) => {
        dispatch({ type: types.EXPANDIR_CONTRAER_MODULO, payload: moduloId })
    }
}

export function showModalSelector(title, fields, url, action, filter = null) {
    return (dispatch) => {
        const fn0 = (d) => d({ type: types.MOSTRAR_MODAL_SELECTOR, payload: { title, fields, url, action } })
        fn0(dispatch)
        if (filter) {
            const fn1 = (d) => d({ type: types.ADICIONAR_FILTRO_MODAL_SELECTOR, payload: filter })
            fn1(dispatch)
        }
        dispatch(getDataFromUrl())
    }
}

export function getDataFromUrl(page = 1) {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {

        const url = getState().common.getIn(['modalSelector', 'url'])
        const pages = getState().common.getIn(['modalSelector', 'pages'])
        const showRecords = getState().common.getIn(['modalSelector', 'showRecords'])
        const filter = getState().common.getIn(['modalSelector', 'filter'])
        const fields = getState().common.getIn(['modalSelector', 'fields'])
        const filters = getState().common.getIn(['modalSelector', 'customFilters']).toJS()

        if (filter) {
            fields.forEach(x => {
                let f = { column: x.get('value'), operator: 'like', value: filter, comparison: 'string', or: true }
                filters.push(f)
            })
        }

        if (pages.filter(x => x === page).count() < 1) {
            const fn0 = (d) => d({ type: types.MODIFICAR_PAGINA_MODAL_SELECTOR, payload: { page } })
            fn0(dispatch)



            axios.get(`${API_URL}${url}`, { params: { page, showRecords, filters }})
            .then((res) => {
                const list = res.data.data
                dispatch({ type: types.ACTUALIZAR_LISTADO_SELECTOR, payload: { list } })
            })
            .catch((err) => {
                displayMessages(dispatch, err)
            })
        }
    }
}


//----------------------------------------------------------------------------------



export function showModalSelectorUrlAirports(title, fields, url, action) {
    return (dispatch) => {
        const fn0 = (d) => d({ type: types.MOSTRAR_MODAL_SELECTOR_AIRPORT, payload: { title, fields, url, action } })
        fn0(dispatch)
        dispatch(getDataFromUrlAirports())
    }
}

// export function getDataFromUrlAirports(query) {

//     const axios = createAxiosInstance()

//     return (dispatch, getState) => {
//         const url = getState().common.getIn(['modalSelectorAirport', 'url'])
//         axios.get(`${API_IATACODES}${url}`, { params: { query }})
//         .then((res) => {
//             if (res.data.response) {
//                 const list = res.data.response.airports
//                 dispatch({ type: types.ACTUALIZAR_LISTADO_SELECTOR_AIRPORT, payload: { list } })
//             }
//         })
//         .catch((err) => {
//             displayMessages(dispatch, err)
//         })

//     }
// }


export function getDataFromUrlAirports(query) {

    const axios = createAxiosInstance()

    return (dispatch, getState) => {
        dispatch({ type: types.SEARCHING_AIRPORTS, payload: true })
        const url = getState().common.getIn(['modalSelectorAirport', 'url'])
        axios.get(`${API_URL}${url}`, { params: { query }})
        .then((res) => {
            if (res.data.airports) {
                const list = res.data.airports_by_cities
                dispatch({ type: types.ACTUALIZAR_LISTADO_SELECTOR_AIRPORT, payload: { list } })
            }
        })
        .catch((err) => {
            displayMessages(dispatch, err)
        })
        .finally(() => {
            dispatch({ type: types.SEARCHING_AIRPORTS, payload: false })
        })
    }
}





export function hideModalSelectorAirport() {
    return (dispatch) => {
        dispatch({ type: types.OCULTAR_MODAL_SELECTOR_AIRPORT })
    }
}


export function clearPagesModalSelectorAirport() {
    return (dispatch) => {
        dispatch({ type: types.REINICIAR_LISTA_MODAL_SELECTOR_AIRPORT })
    }
}

//--------------------------------


export function clearPagesModalSelector() {
    return (dispatch) => {
        dispatch({ type: types.REINICIAR_LISTA_MODAL_SELECTOR })
    }
}

export function hideModalSelectorFromList() {
    return (dispatch) => {
        dispatch({ type: types.OCULTAR_MODAL_SELECTOR })
    }
}

export function updateModalSelectorFilterTerm(value) {
    return (dispatch) => {
        dispatch({ type: types.MODIFICAR_CRITERIO_FILTRADO_MODAL_SELECTOR, payload: value })
    }
}

export function selectFromSelector(type, payload) {
    return (dispatch) => {
        if (isFunction(type)) {
            type()
        } else {
            dispatch({ type, payload })
        }
    }
}

export function getParameterByName(param) {
    return (dispatch, getState) => {
        const queryParam = getState().common.getIn(['parametros', param])
        let gotoSrv = !queryParam
        if (!gotoSrv) gotoSrv = (queryParam.count() === 0)
        if (gotoSrv) {
            const axios = createAxiosInstance()

            axios.get(`${API_URL}/parametros?nombre=${param}`)
            .then((res) => {
                const list = res.data.data
                dispatch({ type: types.ACTUALIZAR_STORE_PARAMETROS, payload: { param, data: res.data } })
            })
            .catch((err) => {
                displayMessages(dispatch, err)
            })
        }
    }
}

export function showHideModalDelete(open, message = null, action = null) {
	return (dispatch) => {
		dispatch({ type: types.MOSTRAR_OCULTAR_MODAL_CONFIRMAR_ACCION, payload: { open, message, action } })
	}
}


export function showModalConfirmarAccion(open, message = null, action = null, hasChildren = false) {
	return (dispatch) => {
		dispatch({ type: types.MODAL_CONFIRMAR_ACCION, payload: { open, message, action, hasChildren } })
	}
}



export function downloadFile(id, filename) {

    const axios = createAxiosInstance()

    return (dispatch) => {
        axios
            .get(`${API_URL}/files/${id}`, { responseType: 'arraybuffer'})
            .then((res) => {
                FileDownload(res.data, filename);
            })
            .catch((err) => {

                const decodedString = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(err.response.data)));

                const obj = {
                    response: {
                        data: decodedString,
                        status: 422
                    }
                }

                displayMessages(dispatch, obj)

            })
	}
}


export function displayModalAddFile(show, title, mode, file, index=0) {
	return (dispatch) => {
		if (show) {
            const fn0 = (d) => d(getParameterByName('CLASIFICACION_ARCHIVOS'))
			fn0(dispatch)
			dispatch({ type: types.MOSTRAR_MODAL_AGREGAR_ARCHIVO, payload: { show, title, mode, file, index } })
		} else {
			dispatch({ type: types.OCULTAR_MODAL_AGREGAR_ARCHIVO })
		}
	}
}

export function showHideModalAddFactura(show, documento, url, type, saldo=0) {
    return (dispatch) => {
        const fn0 = d => d({ type: types.MOSTRAR_MODAL_ADICIONA_FACTURA, payload: { show, documento, url, type, saldo }})
        fn0(dispatch)
    }
}

export function showHideModalAddVerificacionSOMA(show, verificacion, url, type) {
    return (dispatch, getState) => {
        const documentoId = getState().documentos.getIn(['modalSummary', 'data', 'id'])
        if (!verificacion) verificacion = Immutable.fromJS(verificacionSST(documentoId))
        const fn0 = d => d({ type: types.MOSTRAR_MODAL_ADICION_VERIFICACION_SST, payload: { show, verificacion, url, type }})
        fn0(dispatch)
    }
}

export function selectFile(file) {
	return (dispatch) => {
		const fileType = acceptedFiles.filter(x => x.type === file.type)
		let icon = '_blank.png';
		if (fileType.length === 1) {
			icon = fileType[0].icon
		}
		const fn0 = (d) => d({ type: types.MODIFICAR_INPUTS_COMMON_REDUCER, payload: { path: 'modalAddFile.data.nombre', value: file.name } })
		fn0(dispatch)
		const fn1 = (d) => d({ type: types.MODIFICAR_INPUTS_COMMON_REDUCER, payload: { path: 'modalAddFile.data.file', value: file, immutable: false } })
		fn1(dispatch)
		const fn2 = (d) => d({ type: types.MODIFICAR_INPUTS_COMMON_REDUCER, payload: { path: 'modalAddFile.data.icono', value: icon } })
		fn2(dispatch)
	}
}

export function addFile(action) {
	return (dispatch, getState) => {
		const data = getState().common.getIn(['modalAddFile', 'data'])
		const errors = []
		if (!data.get('file')) errors.push('No adicionó ningun archivo')
		if (!data.get('clasificacion')) errors.push('No se seleccionó ninguna clasificación')
		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {
            const fn1 = (d) => d({ type: action, payload: data })
            const fn2 = (d) => d({ type: types.OCULTAR_MODAL_AGREGAR_ARCHIVO })
            fn1(dispatch)
            fn2(dispatch)
		}
	}
}

export function updateInputs(path, value) {

    if(path === 'modalAddFile.data.observaciones'){
        const regex = /[!@#$%^&*()_+\[\]{}|;':",.<>?´áéíóúÁÉÍÓÚ¡]/g;
        value = value.replace(regex, "").toUpperCase();
    }

	return (dispatch, getState) => {
		const fn0 = (d) => d({ type: types.MODIFICAR_INPUTS_COMMON_REDUCER, payload: { path, value } })
		fn0(dispatch);
	}
}

export function uploadFacturaFile(file) {
	return (dispatch) => {
		const fileType = acceptedFiles.filter(x => x.type === file.type)
		let icon = '_blank.png'
		if (fileType.length === 1) {
			icon = fileType[0].icon
		}
		const fn1 = (d) => d({ type: types.MODIFICAR_INPUTS_COMMON_REDUCER, payload: { path: 'modalAddFactura.data.file', value: file, immutable: false } })
		fn1(dispatch)
		const fn2 = (d) => d({ type: types.MODIFICAR_INPUTS_COMMON_REDUCER, payload: { path: 'modalAddFactura.data.icono', value: icon } })
		fn2(dispatch)
	}
}

export function uploadVerificacionSSTFile(file) {
	return (dispatch) => {
		const fileType = acceptedFiles.filter(x => x.type === file.type)
		let icon = '_blank.png';
		if (fileType.length === 1) {
			icon = fileType[0].icon
		}
		const fn1 = (d) => d({ type: types.MODIFICAR_INPUTS_COMMON_REDUCER, payload: { path: 'modalAddVerificacionSOMA.data.file', value: file, immutable: false } })
		fn1(dispatch)
		const fn2 = (d) => d({ type: types.MODIFICAR_INPUTS_COMMON_REDUCER, payload: { path: 'modalAddVerificacionSOMA.data.icono', value: icon } })
		fn2(dispatch)
	}
}

export function storeFactura(last) {
	const axios = createAxiosInstance()
    return (dispatch, getState) => {
        const fn00 = (d) => d(showHideModalLastFactura(false))
        fn00(dispatch)

		const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_ADICIONAR_FACTURA, payload: true })
		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_ADICIONAR_FACTURA, payload: false })
		fn0(dispatch)

		const fn3 = (d) => d(showHideModalAddFactura(false))
		const url = getState().common.getIn(['modalAddFactura', 'url'])
        const type = getState().common.getIn(['modalAddFactura', 'type'])
        const tolerancia = Number(getState().common.getIn(['parametros', 'TOLERANCIA', 0, 'VALOR']))

        const data = getState().common.get('modalAddFactura')
        let objNew = calculoAmortizacion(data.get('data'))
        let objOld = data.get('unchanged')

		const errors = validateFactura(objNew, last, tolerancia)
		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {


            let files = Immutable.fromJS([{
                file: objNew.get('file'),
                clasificacion: 'Factura',
                observaciones: `Factura de venta No. ${objNew.get('numero_factura')}`,
                editable: false,
                guid: guid(),
                tamano: objNew.get('file').size
            }])



            let modificaciones = getModificaciones(objNew, objOld, 'Factura', switchFacturas)
			modificaciones = groupModificacionesBy(modificaciones, 'Factura', 'add')
            if (last) {
                modificaciones.push({
                    id: objNew.get('documento_id'),
                    entity: 'Documento',
                    attribute: 'last',
                    value: true,
                    action: 'replace'
                })
            }


            const anticipo_legalizado = objNew.getIn(['documento','anticipo_legalizado']) || 0
            if (anticipo_legalizado > 0) {
                modificaciones.push({
                    id: objNew.get('documento_id'),
                    entity: 'Documento',
                    value: {
                        anticipo_legalizado, estado: last ? 11 : 10
                    },
                    action: 'edit'
                })
            }

            const otrosis = objNew.getIn(['documento','documentos']).filter(d => d.get('tipo') == 4 && d.get('anticipo_legalizado') > 0)
            otrosis.map(o => {
                modificaciones.push({
                    id: o.get('id'),
                    entity: 'Documento',
                    attribute: 'anticipo_legalizado',
                    value: o.get('anticipo_legalizado'),
                    action: 'replace'
                })
            })


            axios.put(`${API_URL}/${url}`, modificaciones)
                .then(res => {
                    const solicitud = res.data.solicitud
                    const aprobadores = res.data.aprobadores
                    const fn2 = (d) => d({ type: type, payload: { solicitud, aprobadores} })
                    const fn4 = () => toast.success('Los cambios han sido guardados exitosamente', { bodyClassName: 'toastify-content toastify-success' })
                    files = files.setIn(['0', 'documento_id'], res.data.added.Factura[0].documento_id)
                    files = files.setIn(['0', 'factura_id'], res.data.added.Factura[0].id)
                    const fn5 = (d) => d(getDocumento(objNew.get('documento_id')))
                    dispatch(uploadFiles(`/files/${solicitud.id}`, files, [fn1, fn2, fn3, fn4, fn5]))
                })
                .catch(err => {
                    displayMessages(dispatch, err)
                    fn1(dispatch)
                })



        }
    }
}



export function storeVerificacionSST() {
	const axios = createAxiosInstance()
    return (dispatch, getState) => {
		const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_ADICIONAR_FACTURA, payload: true }) //No aparece en actions creators
		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_ADICIONAR_FACTURA, payload: false })
		fn0(dispatch)

		const fn3 = (d) => d(showHideModalAddVerificacionSOMA(false))

        const data = getState().common.get('modalAddVerificacionSOMA')
        const url = data.get('url')
        const type = data.get('type')

        let objNew = data.get('data')
        let objOld = data.get('unchanged')

        let files = Immutable.fromJS([{
            file: objNew.get('file'),
            clasificacion: 'Documentos',
            observaciones: `Soporte de verificación de seguridad y salud en el trabajo`,
            editable: true,
            guid: guid(),
            tamano: objNew.get('file').size
        }])

		const errors = validateVerificacionSST(objNew)
		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {
            let modificaciones = getModificaciones(objNew, objOld, 'VerificacionesSst', switchVerificacionSST)
            modificaciones = groupModificacionesBy(modificaciones, 'VerificacionesSst', (objNew.get('id')) ? 'replace' : 'add')
            axios.put(`${API_URL}/${url}`, modificaciones)
                .then(res => {
                    const solicitud = res.data.solicitud
                    const aprobadores = res.data.aprobadores
                    const fn2 = (d) => d({ type: type, payload: { solicitud, aprobadores } })
                    const fn4 = () => toast.success('Los cambios han sido guardados exitosamente', { bodyClassName: 'toastify-content toastify-success' })
                    files = files.setIn(['0', 'documento_id'], objNew.get('documento_id'))
                    const fn5 = (d) => d(getDocumento(objNew.get('documento_id')))
                    dispatch(uploadFiles(`/files/${solicitud.id}`, files, [fn1, fn2, fn3, fn4, fn5]))
                })
                .catch(err => {
                    console.log(err)
                    displayMessages(dispatch, err)
                    fn1(dispatch)
                })

        }
    }
}

export function canmbiarResponsable(solicitud, type) {

    const axios = createAxiosInstance()

    return (dispatch, getState) => {
        const url = getState().common.getIn(['enums', 'solicitudes', 'tipos', String(solicitud.get('tipo')), 'url'])

        const modificaciones = []

        modificaciones.push({
            id: solicitud.get('id'),
            entity: 'Solicitude',
            attribute: 'responsable_compras_id',
            value: solicitud.getIn(['responsable_compras', 'id']),
            action: 'edit'
        });

        modificaciones.push({
            id: solicitud.get('id'),
            entity: 'Solicitude',
            attribute: 'solicitante_id',
            value: solicitud.getIn(['solicitante', 'id']),
            action: 'edit'
        });

        axios.put(`${API_URL}/solicitudes/${url}/${solicitud.get('id')}`, modificaciones)
        .then(res => {
            const solicitud = res.data.solicitud
            const aprobadores = res.data.aprobadores
            const fn0 = (d) => d({ type: type, payload: { solicitud, aprobadores } })
            const fn1 = () => toast.success('Los cambios han sido guardados exitosamente', { bodyClassName: 'toastify-content toastify-success' })
            fn0(dispatch)
            fn1()
        })
        .catch(err => {
            console.log(err)
            displayMessages(dispatch, err)
        })

    }


}



export function uploadFiles(url, files, actions) {
	const axios = createAxiosInstance()
	return (dispatch) => {

        const errors = validarUpload(files)


		if (errors.length) {
			return errors.forEach(element => {
				toast.warning(element, {bodyClassName: 'toastify-content toastify-warning'})
			})
		} else {

            const formData = new FormData()

            let index = 0;
            let j;

            files.map((f) => {

                if (f.get('id') == null) {
                    formData.append(`files[${index}][file]`, f.get('file'), `${f.get('nombre') || f.get('file').name}`)
                    formData.append(`files[${index}][clasificacion]`, f.get('clasificacion'))
                    formData.append(`files[${index}][observaciones]`, f.get('observaciones') || null)
                    formData.append(`files[${index}][editable]`, f.get('editable'))
                    formData.append(`files[${index}][guid]`, f.get('guid'))
                    formData.append(`files[${index}][tamano]`, f.get('file').size)
                    formData.append(`files[${index}][documento_id]`, f.get('documento_id') || null)
                    formData.append(`files[${index}][factura_id]`, f.get('factura_id') || null)
                    if (f.get('entities')) {
                        j = 0
                        f.get('entities').map(r => {
                            formData.append(`files[${index}][entities][${j}][entity]`, r.get('entity'))
                            formData.append(`files[${index}][entities][${j}][guid]`, r.get('guid'))
                            j++
                        })
                    }
                    index++

                }
            })

            axios.post(`${API_URL}${url}`, formData)
                .then(() => {
                    actions.map(x => x(dispatch))
                })
                .catch(() => {
                    actions.map(x => x(dispatch))
                    toast.error('Se presentó un error al intentar subir los archivos', { bodyClassName: 'toastify-content toastify-danger' })
                })

        }




	}
}



function validarUpload(files) {

	const errors = [];

	if (files.length > 0) {

        const size = files[0].get('file').size

		if (size > uploadMaxSize.value) errors.push(`La capacidad máxima para subir archivos es de de ${uploadMaxSize.unidad}`)
		if (!files[0].get('clasificacion')) errors.push('Debe seleccionar una clasificación')

	}

	return errors
}



const validateFactura = (data, last=false, tolerancia=0) => {

    const errors = []
	if (!data.get('numero_factura')) errors.push('El campo factura número es obligatorio')
    if (!data.get('fecha_factura')) errors.push('El campo fecha de la factura es obligatorio')
    if (data.get('fecha_factura') && moment(data.get('fecha_factura')) > moment())  errors.push('El campo fecha debe ser menor o igual que la de hoy')
	if (!data.get('valor_sin_iva')) errors.push('El campo valor sin IVA es obligatorio')
	if (!data.get('valor_con_iva')) errors.push('El campo valor con IVA es obligatorio')
    if (!data.get('file')) errors.push('Debe adjuntar el documento escaneado')
    const facturas = data.getIn(['documento', 'facturas'])
    if (facturas.filter(f => f.get('numero_factura') == data.get('numero_factura')).count() > 0) errors.push('La factura ya se encuentra registrada')


    const totales = getTotalesDocumento(data.get('documento'))
    //const anticipo = calcularAnticipos(data.get('documento'))


    const saldo_sin_iva = totales.sin_iva - Number(data.get('valor_sin_iva'));
    const saldo_con_iva = totales.con_iva - Number(data.get('valor_con_iva'));
    const tolerancia_sin_iva = Math.abs(totales.sin_iva - Number(data.get('valor_sin_iva')));
    const tolerancia_con_iva = Math.abs(totales.con_iva - Number(data.get('valor_con_iva')));


    if ((data.getIn(['documento', 'entregas_parciales'])) == false) {
        if (tolerancia_sin_iva > tolerancia) errors.push('El valor sin iva de la factura debe ser igual al valor total sin iva del documento.')
        if (tolerancia_con_iva > tolerancia) errors.push('El valor con iva de la factura debe ser igual al valor total con iva del documento.')
    } else {

        if (last && saldo_sin_iva < 0 && tolerancia_sin_iva > tolerancia) {
            errors.push('La suma de los valores sin iva de las factura debe ser igual a la suma de los valores sin iva del documento al cerrar el documento');
        }

        if (!last && saldo_sin_iva < 0 && tolerancia_sin_iva > tolerancia) {
            errors.push('La suma de los valores sin iva de las factura debe ser menor o igual a la suma de los valores sin iva del documento.');
        }

        if (saldo_con_iva < 0 && tolerancia_con_iva > tolerancia) {
            errors.push('La suma de los valores totales de las factura debe ser menor o igual a la suma de los valores totales del documento');
        }

    }

    const verificacion_sst_pendiente = data.getIn(['documento', 'verificaciones_sst']).filter( v => v.get('verificado') == false).count() > 0;

    if (last && verificacion_sst_pendiente) {
        errors.push('Queda pendiente una verificacion de SOMA')
    }


	return errors
}

const validateVerificacionSST = (data) => {
    const errors = []
	if (data.get('aceptado') == 0 && !data.get('observaciones')) errors.push('El campo observaciones es obligatorio')
	if (!data.get('file')) errors.push('Debe adjuntar el soporte escaneado')

	return errors
}

const switchFacturas = (change, modificacion) => {
    const path = [...modificacion.attribute]
	modificacion.attribute = path[0]

    const hidden = ['file', 'guid', 'id', 'icono', 'documento']
    if (hidden.indexOf(modificacion.attribute) !== -1) {
        modificacion.action = 'hidden'
    }
}

const switchVerificacionSST = (change, modificacion) => {
    const path = [...modificacion.attribute]
	modificacion.attribute = path[0]

    const hidden = ['file', 'guid', 'id', 'icono']
    if (hidden.indexOf(modificacion.attribute) !== -1) {
        modificacion.action = 'hidden'
    }
}

export function showHideModalLastFactura(show, action = null) {
    return (dispatch) => {
        const fn2 = d => d({ type: types.MOSTRAR_MODAL_ULTIMA_FACTURA, payload: { show, action }})
        fn2(dispatch)
    }
}

// export function showHideModalAddFirmas(show, contratoanual, url, type) {
//     return (dispatch) => {
//         const fn0 = d => d({ type: types.MOSTRAR_MODAL_ADICION_FIRMAS, payload: { show, contratoanual, url, type }})
//         fn0(dispatch)
//     }
// }



export function showHideModalCreateOtrosi(show, message='') {
    return (dispatch) => {
        const fn1 = d => d({ type: types.MOSTRAR_MODAL_CREATE_OTROSI, payload: { show, message }})
        fn1(dispatch)
    }
}



const obtenerDetalles = (documento) => {

    const totales = {
        sin_iva: 0,
        con_iva: 0,
        sin_iva_sin_adiciones: 0,
        con_iva_sin_adiciones: 0
    }

    documento.get('detalles').forEach(a => {

        totales.sin_iva += a.get('valor') * a.get('cantidad')
        totales.con_iva += a.get('valor_con_iva') * a.get('cantidad')

        if (a.get('adicion_id') === null) {
            totales.sin_iva_sin_adiciones += a.get('valor') * a.get('cantidad')
            totales.con_iva_sin_adiciones += a.get('valor_con_iva') * a.get('cantidad')
        }

    })

    return totales

}


const calculoAmortizacion = (factura) => {

    const documento = factura.get('documento')
    const documentos = []

    documentos.push(documento)

    documento.get('documentos').filter(d => d.get('tipo') == 4).map(x => {
        documentos.push(x)
    })


    const valor_total_documento_sin_iva = documentos.reduce(function(acc1, current1) {
        acc1 += current1.get('detalles').reduce(function(acc2, current2) {
            acc2 += current2.get('valor') * current2.get('cantidad')
            return  acc2
        }, 0)
        return acc1
    }, 0)


    const valor_total_anticipos = documentos.reduce(function(acc1, current1) {
        const anticipo = current1.get('anticipo')
        const total_detalles = current1.get('detalles').reduce(function(acc2, current2) {
            if (current2.get('adicion_id') === null) {
                acc2 += current2.get('valor') * current2.get('cantidad')
            }
            return  acc2
        }, 0)
        acc1 += (anticipo / 100) * total_detalles
        return acc1
    }, 0)

    const anticipo = Math.ceil(((valor_total_anticipos/valor_total_documento_sin_iva) * 100))
    const valor_sin_iva = factura.get('valor_sin_iva') ? factura.get('valor_sin_iva') : 0;
    const valor_con_iva = factura.get('valor_con_iva') ? factura.get('valor_con_iva') : 0;

    if (anticipo > 0) {

        const documentos_con_anticipo = []

        if (documento.get('anticipo') > 0) {
            documentos_con_anticipo.push(documento)
        }

        documento.get('documentos').filter(d => d.get('tipo') == 4 && d.get('anticipo') > 0).map(x => {
            documentos_con_anticipo.push(x)
        })

        let porcentaje_amortizado

        if (documentos_con_anticipo.length > 1) {
            porcentaje_amortizado = anticipo
        } else {
            porcentaje_amortizado = documentos_con_anticipo[0].get('anticipo')
        }

        porcentaje_amortizado = porcentaje_amortizado ? porcentaje_amortizado : 0;

        const valor_descuento = (porcentaje_amortizado / 100) * valor_sin_iva
        let valor_descontado = 0


        for(let i = 0; i < documentos_con_anticipo.length; i++) {

            if (valor_descontado < valor_descuento) {

                let anticipo_legalizado = documentos_con_anticipo[i].get('anticipo_legalizado') || 0
                const total_sin_iva  = obtenerDetalles(documentos_con_anticipo[i]).sin_iva_sin_adiciones
                const valor_anticipo = (documentos_con_anticipo[i].get('anticipo') / 100) * total_sin_iva
                const pendiente_legalizar = valor_anticipo - anticipo_legalizado

                if (pendiente_legalizar > 0) {

                    const pendiente = valor_descuento-valor_descontado

                    if (pendiente <= pendiente_legalizar) {
                        valor_descontado += pendiente
                        anticipo_legalizado += pendiente
                    } else {
                        valor_descontado += pendiente_legalizar
                        anticipo_legalizado = valor_anticipo
                    }

                    if (documentos_con_anticipo[i].get('tipo') != 4) { // Documento original
                        factura = factura.setIn(['documento', 'anticipo_legalizado'], anticipo_legalizado)
                    } else { // Documentos OTROSI
                        const index = factura.getIn(['documento', 'documentos']).findIndex( d => d.get('id') == documentos_con_anticipo[i].get('id'))
                        if (index != -1) {
                            factura = factura.setIn(['documento', 'documentos', index, 'anticipo_legalizado'], anticipo_legalizado)
                        }
                    }

                }

            }
        }


        let valor_a_pagar = valor_con_iva - valor_descontado


        factura = factura.set('amortizacion', valor_descontado)
        factura = factura.set('valor_a_pagar', valor_a_pagar)

        //Calcular amortizacion
        if (valor_descontado < valor_descuento) {
            porcentaje_amortizado = ((valor_descontado / valor_sin_iva) * 100).toFixed(2)
        }

        factura = factura.set('porcentaje_amortizacion', porcentaje_amortizado)

    } else {
        let valor_a_pagar = valor_con_iva;
        factura = factura.set('amortizacion', 0)
        factura = factura.set('valor_a_pagar', valor_a_pagar)
    }

	return factura
}







// WEBPACK FOOTER //
// ./src/actions/common.js